import SearchableList from "./SearchableList";

export default SearchableList;
